import {
  ERA_DETAILS_TYPES,
  CHARGE_WARNINGS,
  CLAIM_WARNINGS,
  isEmptyObject,
} from '../utils';

import { itemHasSpecificWarning } from './utils';

function checkAllLineItemsAreFullyWrittenOff({ lineItems }) {
  const result = lineItems.every(({ errorMessage }) => {
    const normalizedErrorMessage =
      errorMessage === undefined || errorMessage === null || errorMessage === ''
        ? []
        : errorMessage;

    return (
      (Array.isArray(normalizedErrorMessage) &&
        normalizedErrorMessage.length === 0) ||
      itemHasSpecificWarning(
        normalizedErrorMessage,
        CHARGE_WARNINGS.LINE_ITEM_FULLY_WRITTEN_OFF,
      )
    );
  });

  return result;
}

const checkClaimLevel = ({ statusMessage, processedAsPrimary, claim }) =>
  processedAsPrimary &&
  itemHasSpecificWarning(
    statusMessage,
    CLAIM_WARNINGS.CLAIM_WITH_FULLY_WRITTEN_OFF_LINE_ITEM,
  ) &&
  checkAllLineItemsAreFullyWrittenOff(claim);

function isEraLevelOrInvalidParams({ statusMessage, claim, selectedNodeType }) {
  if (selectedNodeType === ERA_DETAILS_TYPES.ERA_LEVEL) {
    return true;
  }

  if (selectedNodeType === ERA_DETAILS_TYPES.CLAIM_LEVEL) {
    return isEmptyObject(statusMessage) || isEmptyObject(claim);
  }

  return isEmptyObject(statusMessage);
}

export default ({
  statusMessage,
  selectedNodeType,
  processedAsPrimary,
  claim,
  hasOmegaEraHandlingFF,
}) => {
  if (isEraLevelOrInvalidParams({ statusMessage, claim, selectedNodeType })) {
    return false;
  }

  const hasFullyWrittenOffWarning = itemHasSpecificWarning(
    statusMessage,
    CHARGE_WARNINGS.LINE_ITEM_FULLY_WRITTEN_OFF,
  );

  const hasAlwaysWarnWarning = hasOmegaEraHandlingFF
    ? itemHasSpecificWarning(
        statusMessage,
        CHARGE_WARNINGS.LINE_ITEM_ALWAYS_WARN,
      )
    : false;

  return selectedNodeType === ERA_DETAILS_TYPES.LINE_ITEM_LEVEL
    ? hasFullyWrittenOffWarning || hasAlwaysWarnWarning
    : checkClaimLevel({ statusMessage, processedAsPrimary, claim });
};
